const LABELS = {
  geral: 'Geral',
  redDot: 'Red Dot',
  mira2x: 'Mira 2x',
  mira4x: 'Mira 4x',
  miraAwm: 'AWM',
  olhadinha: 'Olhadinha'
};

export const renderFreefireCalculatorResult = (data = {}) => {
  const sensitivities = data.sensitivities || {};
  const rows = Object.entries(LABELS)
    .map(([key, label]) => sensitivities[key] !== undefined ? `${label}: ${sensitivities[key]}` : null)
    .filter(Boolean)
    .join('\n');

  const explanations = Array.isArray(data.explanations)
    ? data.explanations.slice(0, 2).join('\n')
    : null;
  const testPlan = Array.isArray(data.testPlan)
    ? data.testPlan.slice(0, 3).map((step) => `- ${step.title}: ${step.description}`).join('\n')
    : null;

  return [
    'Sensibilidade Free Fire calculada',
    rows || null,
    data.dpiRecommendation ? `DPI recomendada: ${data.dpiRecommendation}` : null,
    data.buttonSizeRecommendation ? `Botao de tiro: ${data.buttonSizeRecommendation}%` : null,
    data.confidenceScore ? `Confianca: ${data.confidenceScore}%` : null,
    explanations,
    testPlan ? `Teste agora:\n${testPlan}` : null
  ].filter(Boolean).join('\n\n');
};

export const renderFreefireCalculatorHumanError = ({ status, message } = {}) => {
  if (status === 403) {
    return message || 'A Calculadora Free Fire depende do seu acesso Pro ou Vitalicio Free Fire.';
  }
  return message || 'Nao consegui calcular Free Fire agora. Tenta novamente em instantes.';
};

export default renderFreefireCalculatorResult;
